import { useInjection } from '@cp/shared/di';
import { FAVORITES_SERVICE } from '../di';

export const useFavoritesService = () => useInjection(FAVORITES_SERVICE);
